<!--template>
  <div>
    <v-container>
        <advice color="primary">
            <span class="caption grey--text text--darken-1"
                v-html="$t('profile.platesList.noPlates')">
            </span>
        </advice>
    </v-container>
  </div>
</template-->
<template>
  <v-container class="minHeight"
               v-if="loaded">
    <v-card v-if="!hasRows"
            class="py-4">
      <advice color="primary">
        <p v-html="$t('circleList.message.noCircles')"></p>
      </advice>
      <v-card-actions class="px-4 pb-3">
      <v-spacer></v-spacer>

          <v-btn round
                 flat
                 color="accent"
                 class="capitalize"
                 outline
                 @click="isShowingCircleCreateBottomSheet = !isShowingCircleCreateBottomSheet">
            {{$t('circleList.button.redeem')}}
          </v-btn>
        </v-card-actions>
    </v-card>

    <v-card v-else>

      <v-layout row
                class="pb-4">
        <v-flex xs12>
          <v-data-table :headers="headers"
                        :items="circles"
                        hide-actions
                        expand
                        item-key="code">
            <template slot="items"
                      slot-scope="props">
              <td class="text-xs-left">{{ props.item.title }}</td>
              <td class="text-xs-left">{{ props.item.description }}</td>
              <td class="justify-center layout px-0">
                <v-btn icon
                       class="error"
                       color="error"
                       outline
                       @click="showCircleDeleteDialog(props.item)">
                  <v-icon>delete</v-icon>
                </v-btn>
              </td>
            </template>
          </v-data-table>
        </v-flex>
      </v-layout>

      <v-card-actions class="px-4 pb-3">
      <v-spacer></v-spacer>

          <v-btn round
                 flat
                 color="accent"
                 class="capitalize"
                 outline
                 @click="isShowingCircleCreateBottomSheet = !isShowingCircleCreateBottomSheet">
            {{$t('circleList.button.redeem')}}
          </v-btn>
        </v-card-actions>
    </v-card>

    <delete-circle :plate="selectedCircle"
                    v-if="isShowingCircleDeleteDialog"
                    @on-success="getuserCircles"
                    @on-close="closeCircleDeleteDialog"></delete-circle>

    <create-circle v-if="isShowingCircleCreateBottomSheet"
                      @on-success="getuserCircles"
                      @on-close="closeCircleCreateBottomSheet"></create-circle>

  </v-container>
</template>

<script>
import Advice from '@/components/commons/Advice';
import circleService from '@/services/circleService';
import manageErrorService from '@/services/manageErrorService';
import CreateCircle from '@/components/private/user/CreateCircle';
import DeleteCircle from '@/components/private/user/DeleteCircle';
export default {
  name: 'CirclesList',
  components: {
    [Advice.name]: Advice,
    [CreateCircle.name]: CreateCircle,
    [DeleteCircle.name]: DeleteCircle
  },
  computed: {

    headers() {
      return [
          {
            i18nText: 'circleList.list.title',
            text: this.$i18n.t('circleList.list.title'),
            align: 'left',
            value: 'title'
          },
          {
            i18nText: 'circleList.list.description',
            text: this.$i18n.t('circleList.list.description'),
            align: 'left',
            value: 'description'
          },
          {
            i18nText: '',
            text: '',
            align: 'right',
            value: ''
          }
        ];
    }
  },
  data() {
    return {
      loaded: false,
      hasRows: false,
      isShowingCircleCreateBottomSheet: false,
      isShowingCircleDeleteDialog: false,
      selectedCircle: {},
      circles: []
    };
  },
  mounted() {},
  created() {
    this.getuserCircles();
  },
  destroyed() {},
  methods: {
    async getuserCircles() {
      let params = {};
      let results = await circleService.list(params);

      if (results.error) {
        manageErrorService.handle(results.data);
        return;
      }

      this.circles = results.data;

      if (this.circles.length === 0) {
        this.hasRows = false;
      } else {
        this.hasRows = true;
      }
      this.loaded = true;
    },
    showCircleDeleteDialog(item) {
      this.isShowingCircleDeleteDialog = true;
      this.selectedCircle = item;
    },
    closeCircleDeleteDialog() {
      this.isShowingCircleDeleteDialog = false;
      this.selectedCircle = {};
    },
    closeCircleCreateBottomSheet() {
      this.isShowingCircleCreateBottomSheet = false;
    }
  }
};
</script>
